import {
  createSlice,
  createAsyncThunk,
  PayloadAction,
  current,
} from "@reduxjs/toolkit";
import {pharmacyStoreService} from "api";
import Notification from "components/common/notification/notification";
import {LOAI_PHIEU_KHO, TT_PHIEU_KHO, LOAI_FORM} from "types/enums";

export interface State {
  listPharmacy: any[];
  currentOptionsUnit: any[];
  activeTabAllocation: any;
  listStore: any[];
  listPharmacyGroup: any[];
  listSupplier: any[];
  typePhieu: LOAI_PHIEU_KHO; // loại phiếu: nhập/xuất/dự trù
  typeForm: LOAI_FORM; // loại: tạo mới/xem chi tiết
  statusPhieu: TT_PHIEU_KHO; // Trạng thái : nháp/chờ duyêt/ đã duyệt/hoàn thành
  selectedRecord: any; // bản ghi phiếu đc chọn
  detailRecord: any;
  loading: boolean;
  selectedMedicinesExport: any[];
  detailRef: any;
  dataTable: any[];
  idReceipt: any[];
}

const initialState: State = {
  listPharmacy: [],
  currentOptionsUnit: [],
  activeTabAllocation: null,
  listStore: [],
  listPharmacyGroup: [],
  listSupplier: [],
  typePhieu: null,
  typeForm: null,
  statusPhieu: null,
  selectedRecord: null,
  detailRecord: null,
  loading: false,
  selectedMedicinesExport: [],
  detailRef: null,
  dataTable: [],
  idReceipt: null,
};

export const pharmacyStoreSlice = createSlice({
  name: "pharmacyStore",
  initialState: initialState,
  reducers: {
    setListPharmacy: (state = initialState, action: PayloadAction<any>) => {
      return {...state, listPharmacy: action.payload};
    },
    setDataTable: (state = initialState, action: PayloadAction<any>) => {
      return {...state, dataTable: action.payload};
    },
    addCurrentOptionsUnit: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      return {
        ...state,
        currentOptionsUnit: [...state.currentOptionsUnit, action.payload],
      };
    },
    setListStore: (state = initialState, action: PayloadAction<any>) => {
      return {...state, listStore: action.payload};
    },
    setActiveTabAllocation: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      return {...state, activeTabAllocation: action.payload};
    },
    setListPharmacyGroup: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      return {...state, setListPharmacyGroup: action.payload};
    },
    setListSupplier: (state = initialState, action: PayloadAction<any>) => {
      return {...state, listSupplier: action.payload};
    },

    setTypePhieu: (state = initialState, action: PayloadAction<any>) => {
      return {...state, typePhieu: action.payload};
    },
    setTypeForm: (state = initialState, action: PayloadAction<any>) => {
      return {...state, typeForm: action.payload};
    },
    setStatusPhieu: (state = initialState, action: PayloadAction<any>) => {
      return {...state, statusPhieu: action.payload};
    },
    setSelectedRecord: (state = initialState, action: PayloadAction<any>) => {
      return {...state, selectedRecord: action.payload};
    },
    setDetailRecord: (state = initialState, action: PayloadAction<any>) => {
      return {...state, detailRecord: action.payload};
    },
    setLoading: (state = initialState, action: PayloadAction<any>) => {
      return {...state, loading: action.payload};
    },
    setDetailRef: (state = initialState, action: PayloadAction<any>) => {
      return {...state, detailRef: action.payload};
    },
    setSelectedMedicinesExport: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      return {...state, selectedMedicinesExport: action.payload};
    },
    setIdReceipt: (state = initialState, action: PayloadAction<any>) => {
      return {...state, idReceipt: action.payload};
    },
  },
});

export const {
  setListPharmacy,
  addCurrentOptionsUnit,
  setListStore,
  setActiveTabAllocation,
  setListPharmacyGroup,
  setListSupplier,
  setTypePhieu,
  setTypeForm,
  setStatusPhieu,
  setSelectedRecord,
  setDetailRecord,
  setDataTable,
  setSelectedMedicinesExport,
  setDetailRef,
  setIdReceipt,
} = pharmacyStoreSlice.actions;
export const getListStore = () => {
  return async dispatch => {
    try {
      const res = (await pharmacyStoreService.getListStore(1, 30)) || [];

      dispatch(setListStore(res.data));
    } catch (error) {
      Notification("error", "Đã có lỗi khi lấy danh sách kho");
    }
  };
};
export const getListStorePhanQuyen = () => {
  return async dispatch => {
    try {
      const res =
        (await pharmacyStoreService.getListStorePhanQuyen(1, 30)) || [];

      dispatch(setListStore(res.data));
    } catch (error) {
      Notification("error", "Đã có lỗi khi lấy danh sách kho");
    }
  };
};
export const updateDetailLo = params => {
  return async dispatch => {
    try {
      const res = (await pharmacyStoreService.updateDetailLo(params)) || null;
      Notification("success", "Đã cập nhật thông tin lô");
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi cập nhật thông tin lô");
    }
  };
};
export const getListSupplier = () => {
  return async dispatch => {
    try {
      const res = (await pharmacyStoreService.getListSupplier(1, 50)) || [];

      dispatch(setListSupplier(res.data));
    } catch (error) {}
  };
};
export default pharmacyStoreSlice.reducer;
